import React from "react";
import PropTypes from "prop-types";
import { CustomIconButton, IconComponent, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import styles from "./DetectionBanner.module.css";

export default function DetectionBanner({ hasLaunchFinished, progress, onCloseBanner }) {
	return (
		<div className={styles.progressBanner} data-has-finished={hasLaunchFinished}>
			{(progress || hasLaunchFinished) && (
				<>
					<IconComponent
						color={(progress && "var(--blue-500)") || "var(--lime-500)"}
						icon={icon[(progress && "faSpinner") || "faCheckSquare"]}
						size="sm"
						spin={!!progress}
					/>
					<div className={styles.progressBanner__text}>
						<div className={styles["progressBanner__text--title"]}>
							{(progress &&
								translate("commitment-tracking.detection-banner.title", {
									progress,
								})) ||
								translate("commitment-tracking.detection-banner.title.finished")}
						</div>
						<span>
							{translate(
								(progress && "commitment-tracking.detection-banner.message") ||
									"commitment-tracking.detection-banner.message.finished"
							)}
						</span>
					</div>
					{hasLaunchFinished && <CustomIconButton icon={icon.faXmark} onClick={() => onCloseBanner(false)} />}
				</>
			)}
		</div>
	);
}

DetectionBanner.propTypes = {
	progress: PropTypes.string.isRequired,
};
